if (!customElements.get('vertical-media-component')) {
  customElements.define(
    'vertical-media-component',
    class VerticalMediaComponent extends HTMLElement {
      constructor() {
        super();

        this.sliderInstance = false;
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.selectedIndex = this.selectedIndex;
        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.containerWidth = this.dataset.container;
        this.borderRadius = this.dataset.borderRadius;

        // 根据屏幕宽度选择不同的 pagination
        const isMobile = window.innerWidth < 768;
        this.customPagination = isMobile
          ? this.querySelector('.vertical-media-change__horizontal-pagination')
          : this.querySelector('.vertical-media-change__swiper-pagination');

        this.prevButton = this.section?.querySelector('.vertical-media-change__button-prev');
        this.nextButton = this.section?.querySelector('.vertical-media-change__button-next');

        if (!this.enableSlider) return;

        this.initSlider();
      }

      static get observedAttributes() {
        return ['selected-index'];
      }

      get selectedIndex() {
        return parseInt(this.getAttribute('selected-index')) || 0;
      }

      set selectedIndex(index) {
        this.setAttribute('selected-index', `${index}`);
      }

      initSlider() {
        const additionModules = [];

        // 检测是否为移动端，小于768px使用水平切换
        const isMobile = window.innerWidth < 768;

        this.sliderOptions = {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: false,
          grabCursor: true,
          allowTouchMove: true,
          autoHeight: true,
          threshold: 2,
          direction: isMobile ? 'horizontal' : 'vertical',
          on: {
            init: this.handleAfterInit.bind(this),
            slideChange: this.handleSlideChange.bind(this),
          },
        };

        // Custom pagination with text bullets
        if (this.customPagination) {
          const bullets = this.customPagination.querySelectorAll('.swiper-pagination-bullet');
          bullets.forEach((bullet, index) => {
            bullet.addEventListener('click', () => {
              if (this.sliderInstance && this.sliderInstance.slider) {
                this.sliderInstance.slider.slideTo(index);
              }
            });
          });
        }

        // Navigation buttons
        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => {
            if (this.sliderInstance && this.sliderInstance.slider) {
              this.sliderInstance.slider.slidePrev();
            }
          });
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => {
            if (this.sliderInstance && this.sliderInstance.slider) {
              this.sliderInstance.slider.slideNext();
            }
          });
        }

        this.sliderInstance = new window.FoxTheme.Carousel(this.querySelector('.swiper'), this.sliderOptions, additionModules);
        this.sliderInstance.init();

        this.sliderInstance.slider.on('realIndexChange', this.handleSlideChange.bind(this));

        if (this.sliderInstance) {
          this.selectedElement = this.sliderInstance.slider.slides[this.sliderInstance.slider.activeIndex];
          this.onReady(this.selectedElement, this.sliderInstance.slider.slides);

          // Fix accessibility
          const focusableElements = FoxTheme.a11y.getFocusableElements(this);
          focusableElements.forEach((element) => {
            element.addEventListener('focusin', () => {
              const slide = element.closest('.swiper-slide');
              if (slide) {
                const slideIndex = Array.from(this.sliderInstance.slider.slides).indexOf(slide);
                this.sliderInstance.slider.slideTo(slideIndex);
              }
            });
          });
        }
      }

      onReady(selectedElement) {
        if (selectedElement.dataset.type === 'video') {
          const videoElement = FoxTheme.utils.displayedMedia(selectedElement.querySelectorAll('video-element'));
          videoElement?.play();
        }

        if (!FoxTheme.config.motionReduced) {
          const motionEls = selectedElement.querySelectorAll('motion-element');
          motionEls.forEach((motionEl) => {
            setTimeout(() => {
              motionEl && motionEl.refreshAnimation();
            });
          });
        }
      }

      handleAfterInit() {
        this.removeAttribute('data-media-loading');

        // Set initial active pagination bullet
        this.updatePagination(0);
      }

      handleSlideChange(swiper) {
        const { slides, activeIndex } = swiper;
        this.selectedIndex = activeIndex;

        this.updatePagination(activeIndex);

        // Handle video play/pause
        slides.forEach((slide, index) => {
          if (slide.dataset.type === 'video') {
            const videoElement = FoxTheme.utils.displayedMedia(slide.querySelectorAll('video-element'));
            if (index === activeIndex) {
              videoElement?.play();
            } else {
              videoElement?.pause();
            }
          }
        });

        // Handle motion animations
        if (!FoxTheme.config.motionReduced) {
          const activeSlide = slides[activeIndex];
          const motionEls = activeSlide.querySelectorAll('motion-element');
          motionEls.forEach((motionEl) => {
            setTimeout(() => {
              motionEl && motionEl.refreshAnimation();
            });
          });
        }
      }

      updatePagination(activeIndex) {
        if (this.customPagination) {
          const bullets = this.customPagination.querySelectorAll('.swiper-pagination-bullet');
          const isMobile = window.innerWidth < 768;

          bullets.forEach((bullet, index) => {
            if (index === activeIndex) {
              bullet.classList.add('swiper-pagination-bullet-active');

              // 仅在桌面端处理 description 的动画
              if (!isMobile) {
                const description = bullet.querySelector('.vertical-media-change__swiper-pagination-description');
                if (description) {
                  // Set height to auto temporarily to measure actual height
                  description.style.height = 'auto';
                  const fullHeight = description.scrollHeight + 'px';
                  description.style.height = '0';

                  // Force reflow
                  description.offsetHeight;

                  // Animate to full height
                  description.style.height = fullHeight;

                  // Clean up after animation
                  setTimeout(() => {
                    if (bullet.classList.contains('swiper-pagination-bullet-active')) {
                      description.style.height = 'auto';
                    }
                  }, 400);
                }
              }
            } else {
              bullet.classList.remove('swiper-pagination-bullet-active');

              // 仅在桌面端处理 description 的动画
              if (!isMobile) {
                const description = bullet.querySelector('.vertical-media-change__swiper-pagination-description');
                if (description) {
                  // Set current height first
                  description.style.height = description.scrollHeight + 'px';

                  // Force reflow
                  description.offsetHeight;

                  // Animate to 0
                  description.style.height = '0';
                }
              }
            }
          });
        }
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'selected-index' && oldValue !== null && oldValue !== newValue) {
          const fromElements = this.querySelectorAll(`[data-index="${oldValue}"]`);
          const toElements = this.querySelectorAll(`[data-index="${newValue}"]`);

          fromElements.forEach((fromElement) => {
            if (fromElement.dataset.type === 'video') {
              const videoElement = FoxTheme.utils.displayedMedia([fromElement.querySelector('video-element')]);
              videoElement && videoElement.pause();
            }

            const motionEls = fromElement.querySelectorAll('motion-element');
            motionEls &&
              motionEls.forEach((motionEl) => {
                if (motionEl.hasAttribute('data-text')) {
                  motionEl.resetAnimation();
                }
              });
          });

          toElements.forEach((toElement) => {
            setTimeout(() => {
              if (toElement.classList.contains('swiper-slide-active')) {
                if (toElement.dataset.type === 'video') {
                  const videoElement = FoxTheme.utils.displayedMedia([toElement.querySelector('video-element')]);
                  videoElement && videoElement.play();
                }

                const motionEls = toElement.querySelectorAll('motion-element');
                motionEls.forEach((motionEl) => {
                  setTimeout(() => {
                    motionEl && motionEl.refreshAnimation();
                  });
                });
              }
            });
          });
        }
      }
    }
  );
}